import { createSlice } from '@reduxjs/toolkit';

// eslint-disable-next-line @typescript-eslint/ban-types
export type CommonReduxState = {};

const initialState: CommonReduxState = {};

const commonSlice = createSlice({
  initialState,
  name: 'common',
  reducers: {},
});

export const { reducer: commonReducer } = commonSlice;
